import * as request from '../api-request'

export const createJob = async (data) => {
  return request.toJSON('POST', 'script_doctor', data)
}

export const cancelJob = async (data) => {
  return request.toJSON('POST', 'script_doctor/cancel_job', data)
}

export const getJobStatus = async (data) => {
  const queryString = new URLSearchParams(data)
  return request.toJSON('GET', `script_doctor?${queryString}`, data)
}

export const getScenes = async (data) => {
  return request.toJSON('POST', 'script_doctor/scenes', data)
}

export const markAsApplied = async (data) => {
  return request.toJSON('POST', 'script_doctor/applied', data)
}

export const markAsIgnored = async (data) => {
  return request.toJSON('POST', 'script_doctor/ignore', data)
}
